import { FundraisingDisclosures } from './FundraisingDisclosures';
import { LINK_COPY } from './linkCopy';
import { LinkPage } from './LinkPage';

/** Manage ARC › Fundraising: the link behind the ARC's Donate button (US-110). */
export function FundraisingPage() {
  return (
    <LinkPage
      kind="fundraising"
      copy={LINK_COPY.fundraising}
      disclosures={<FundraisingDisclosures />}
    />
  );
}
